import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper _flexcntr" }
const _hoisted_2 = { class: "gfu-1of1 gfu-2of4--m gfu-1of3--l" }
const _hoisted_3 = {
  class: "gfu-box gfu-box--thick _mt-6 _mb-3",
  "data-qa": "reset-password-box"
}
const _hoisted_4 = { class: "gfu-heading gfu-heading--soft gfu-box__title" }
const _hoisted_5 = { class: "_tac _mb-1" }
const _hoisted_6 = {
  class: "gfu-fields",
  "data-qa": "request-reset-password-form"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "_tac _mt-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.Resources.ResetPassword.ResetPasswordHeader), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.Resources.ResetPassword.ResetPasswordParagraph), 1 /* TEXT */),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("fieldset", null, [
              _createVNode(_component_field, {
                "display-name": _ctx.Resources.ResetPassword.ResetPasswordEmailFieldLabel,
                name: "model.email",
                "data-qa": "request-reset-password-form:Email"
              }, {
                default: _withCtx(({ fieldId }) => [
                  _withDirectives(_createElementVNode("input", {
                    id: fieldId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.email) = $event)),
                    class: "gfu-field__input",
                    type: "email",
                    name: "email",
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent","stop"]), ["enter"])),
                    "data-qa": "text-field-input"
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
                    [_vModelText, $data.model.email]
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["display-name"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_field, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_button, {
                      theme: "accent",
                      display: "block",
                      width: "wide",
                      onClick: $options.submit,
                      "data-qa": "request-reset-password-form-button:ResetPassword"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.ResetPassword.ResetPasswordSubmitButton), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ]),
          _createVNode(_component_progress_overlay, {
            visible: _ctx.isProcessing,
            "data-qa": "request-reset-password-form:ProgressOverlay"
          }, null, 8 /* PROPS */, ["visible"])
        ])
      ])
    ])
  ]))
}